import {
  useFetch,
  usePartialPost,
  usePost,
  useUpdate,
} from "../utilities/react-query";

const usersURL = "/web-twinprocms/users";

export const useGetUsersList = ({ limit, offset, role, name, editor_id }: any) => {
  const editorQuery = editor_id ? `&editor_id=${editor_id}` : "";
  const response: any = useFetch<any[]>(
    `${usersURL}?limit=${limit}&offset=${offset}&role=${role}&first_name=${name}${editorQuery}`
  );
  return {
    ...response,
    data: response?.data ?? {},
  };
};

export const useGetEditors = (config?: { enabled?: boolean }) => {
  const response: any = useFetch<any[]>(
    `${usersURL}?limit=1000&offset=0&role=Editor&first_name=`,
    undefined,
    { enabled: config?.enabled !== false }
  );
  const users = response?.data?.data ?? [];
  return {
    ...response,
    data: users.filter((user: any) => user?.is_active !== false),
  };
};

export const useCreateUser = (
  updater: (oldData: any[], newData: any) => any[]
) =>
  usePost<any[], any>(`${usersURL}/create`, undefined, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const useUpdateUser = (id: number) =>
  useUpdate<any, any>(`${usersURL}/${id}/update`, undefined, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const useResetUserPassword = () =>
  usePartialPost<any, any>(usersURL, "password-reset");

export const useChangeUserStatus = () =>
  usePartialPost<any, any>(usersURL, "status");
